import { render, staticRenderFns } from "./read-article.vue?vue&type=template&id=b643eec8&scoped=true&"
import script from "./read-article.vue?vue&type=script&lang=js&"
export * from "./read-article.vue?vue&type=script&lang=js&"
import style0 from "./read-article.vue?vue&type=style&index=0&id=b643eec8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b643eec8",
  null
  
)

export default component.exports